import { decode } from 'base64-arraybuffer'

/**
 * Returns true if the given attachment is an image.
 * @param {Pick<AttachmentResource, 'mime_type'>} attachment
 */
export const isImage = (attachment) => !!attachment.mime_type.match('image/*')

/**
 * Returns true if the given attachment is a PDF.
 * @param {Pick<AttachmentResource, 'mime_type'>} attachment
 */
export const isPdf = (attachment) =>
  !!attachment.mime_type.match('application/pdf')

/**
 * Returns true if the given attachment is an Excel spreadsheet.
 * @param {Pick<AttachmentResource, 'mime_type'>} attachment
 */
export const isXlsx = (attachment) =>
  !!attachment.mime_type.match('officedocument.spreadsheetml.sheet') ||
  !!attachment.mime_type.match('application/vnd.ms-excel')

export const base64ToFile = ({ base64, name, type }) => {
  const buffer = decode(base64)
  return new File([buffer], name, {
    type
  })
}

export const base64ToBlob = ({ base64, type }) => {
  const binStr = Buffer.from(base64, 'base64').toString('binary')
  const len = binStr.length
  const arr = new Uint8Array(len)
  for (let i = 0; i < len; i += 1) {
    arr[i] = binStr.charCodeAt(i)
  }
  return new Blob([arr], { type })
}
